// 모바일 메뉴 - 슬라이드
(() => {
  const SLIDER_SELECTOR = '.neo-drawer-menu-banner__slide .swiper';
  const CLONE_ATTRIBUTE = 'data-neo-menu-clone';
  const SLIDES_PER_VIEW = 2.6;
  const MIN_LOOP_SLIDES = 6;

  const initializedInstances = new WeakSet();

  function getSliders(root = document) {
    const sliders = [...root.querySelectorAll(SLIDER_SELECTOR)];

    if (root.matches?.(SLIDER_SELECTOR)) {
      sliders.unshift(root);
    }

    return sliders;
  }

  function removeClones(wrapper) {
    [...wrapper.children].forEach((slide) => {
      if (slide.hasAttribute(CLONE_ATTRIBUTE)) {
        slide.remove();
      }
    });
  }

  function initMenuBannerSwipers(root = document) {
    if (typeof Swiper === 'undefined') return;

    getSliders(root).forEach((slider) => {
      const existingSwiper = slider.swiper;

      // 이 코드로 이미 초기화했다면 중복 실행 방지
      if (
        existingSwiper &&
        !existingSwiper.destroyed &&
        initializedInstances.has(existingSwiper)
      ) {
        return;
      }

      // 다른 코드로 초기화된 인스턴스가 있으면 정리
      if (existingSwiper && !existingSwiper.destroyed) {
        existingSwiper.destroy(true, true);
      }

      const wrapper = slider.querySelector(':scope > .swiper-wrapper');
      if (!wrapper) return;

      // 재초기화 시 이전 복제본 제거
      removeClones(wrapper);

      const originalSlides = [...wrapper.children].filter((slide) =>
        slide.classList.contains('swiper-slide')
      );

      const originalCount = originalSlides.length;
      if (!originalCount) return;

      const useLoop = originalCount > 1;

      // 원본 순서를 유지하며 최소 6개 확보
      // 예: 3개 → 1, 2, 3, 1, 2, 3
      if (useLoop && originalCount < MIN_LOOP_SLIDES) {
        const totalSets = Math.ceil(MIN_LOOP_SLIDES / originalCount);
        const fragment = document.createDocumentFragment();

        for (let set = 1; set < totalSets; set++) {
          originalSlides.forEach((slide) => {
            const clone = slide.cloneNode(true);

            clone.setAttribute(CLONE_ATTRIBUTE, '');
            clone.removeAttribute('data-swiper-slide-index');

            fragment.appendChild(clone);
          });
        }

        wrapper.appendChild(fragment);
      }

      const swiper = new Swiper(slider, {
        loop: useLoop,
        slidesPerView: SLIDES_PER_VIEW,
        slidesPerGroup: 1,
        spaceBetween: 0,
        speed: 300,
        watchOverflow: true,
        resizeObserver: true,
      });

      initializedInstances.add(swiper);
    });
  }

  // 최초 페이지 로드
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initMenuBannerSwipers(),
      { once: true }
    );
  } else {
    initMenuBannerSwipers();
  }

  // 테마 편집기: 섹션 다시 로드
  document.addEventListener('shopify:section:load', (event) => {
    initMenuBannerSwipers(event.target);
  });

  // 테마 편집기: 섹션 제거 시 정리
  document.addEventListener('shopify:section:unload', (event) => {
    getSliders(event.target).forEach((slider) => {
      const swiper = slider.swiper;

      if (swiper && !swiper.destroyed) {
        swiper.destroy(true, true);
      }

      const wrapper = slider.querySelector(':scope > .swiper-wrapper');

      if (wrapper) {
        removeClones(wrapper);
      }
    });
  });
})();

